export const productShortName = 'Scienze Forensi — Edizione Docenti';
export const productBrand = 'Scienze Forensi';
export const productEdition = 'Edizione Docenti';
export const productImage = 'https://cdn.magicpatterns.com/uploads/vCaYd1necS1LymAF4PU5ox/MOCKUP_FORENSI.png';
export const productImageAlt =
  'Scienze Forensi Edizione Docenti: collezione didattica in 6 volumi con 5 risorse bonus, disponibile su tablet e smartphone';

export const checkoutUrl = 'https://scienze-forensi-docenti.impultienda.ar/checkout';

export const price = '€19';
export const priceBefore = '€80';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = '€17';
export const bonusTotalValue = '€85';

export const assurances = ['Pagamento sicuro', 'Accesso immediato', 'Garanzia di 7 giorni'];

export const closingLines = [
  'Basta preparare ogni lezione da zero',
  'Basta spiegare prove e impronte senza materiali chiari',
  'Basta cercare attività e casi di studio sparsi su internet',
  "Basta verifiche improvvisate all'ultimo minuto",
  'Basta studenti distratti durante le lezioni di scienze',
];
